import { OfflineDataFetcher } from "@skinsoft/offline"
import { Authority } from "@skinsoft/types"

export class AuthorityOfflineDataFetcher extends OfflineDataFetcher<Authority> {
    constructor(cacheKey: string) {
        super(cacheKey)
    }
}